import { render, staticRenderFns } from "./classifiersMainView.vue?vue&type=template&id=34b32eff&scoped=true&"
import script from "./classifiersMainView.vue?vue&type=script&lang=js&"
export * from "./classifiersMainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b32eff",
  null
  
)

export default component.exports